import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGE_CODES, LANGUAGES } from "@dosia/shared";
import { cn } from "../lib/cn.js";

/**
 * 语言切换（OPT-8 PR-6）：changeLanguage 立即重渲染所有 t()，detector 同步写
 * localStorage(i18nextLng) 供刷新/重开回灌。语言集与 endonym 复用 @dosia/shared
 * 单源；本组件只是 admin 面的入口控件（顶栏 + 登录页各挂一处）。
 */
export function LanguageSwitcher({
  className,
}: {
  className?: string;
}): JSX.Element {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? i18n.language;

  return (
    <select
      aria-label={t("admin.language.label")}
      value={current}
      onChange={(e) => {
        void i18n.changeLanguage(e.target.value);
      }}
      className={cn(
        "rounded border border-dosia-border bg-dosia-bg-light px-2 py-1 text-xs text-dosia-text-secondary hover:bg-dosia-bg-lighter focus:border-dosia-accent focus:outline-none",
        className,
      )}
    >
      {SUPPORTED_LANGUAGE_CODES.map((code) => (
        <option key={code} value={code}>
          {LANGUAGES[code].nativeName}
        </option>
      ))}
    </select>
  );
}
